import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyServices } from "../../api/apiServices";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي للخدمات (soft delete)
 */
export function useDeleteAllServices() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllServicesMutate,
        isPending,
    } = useMutation({
        mutationFn: massDestroyServices,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete services");
        },
    });

    return {
        deleteAllServicesMutate,
        isPending,
    };
}